
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.227 4.977c-.651-.563-1.086-1.013-1.305-1.352-.219-.344-.328-.682-.328-1.016 0-.536.226-.971.68-1.304.453-.339 1.06-.508 1.82-.508 1.088 0 2.01.279 2.765.836v1.133h-.75c-.421-.896-1.088-1.344-2-1.344-.442 0-.78.099-1.015.297-.23.192-.344.424-.344.695 0 .245.102.484.305.719.203.234.794.758 1.773 1.57.787.656 1.362 1.281 1.727 1.875.364.594.547 1.297.547 2.11 0 1.03-.326 1.861-.977 2.492-.651.63-1.474.945-2.469.945-1 0-1.81-.315-2.43-.945-.62-.636-.93-1.456-.93-2.461 0-1.823.977-3.07 2.93-3.742zm.562.46c-1.354.594-2.031 1.732-2.031 3.415 0 .791.174 1.432.523 1.921.354.49.808.735 1.36.735.63 0 1.12-.253 1.468-.758.355-.51.532-1.198.532-2.063 0-.645-.149-1.218-.446-1.718-.291-.5-.76-1.01-1.406-1.532z","fill":"currentColor"}})])
          )
        }
      }
    